"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var document_operations_service_1 = require("../../../shared/services/api/document-operations.service");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var Observable_1 = require("rxjs/Observable");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var file_utils_1 = require("../../../shared/utils/file-utils");
var from_1 = require("rxjs/observable/from");
var static_method_1 = require("../../../shared/utils/static-method");
var converted_document_1 = require("../../../shared/model/converted-document");
var DocumentOcrPreviewControlComponent = /** @class */ (function () {
    function DocumentOcrPreviewControlComponent(documentOperationsService, deService, http, applicationPropertiesService) {
        this.documentOperationsService = documentOperationsService;
        this.deService = deService;
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.textContent = null;
        // Private
        this._pageNumber = 1;
        this._destroy$ = new Subject_1.Subject();
        this._documentServiceUrlKey = 'document-service-url';
        this._documentContentPath = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/document/content/", ""], ["", "/document/content/", ""])), 'serviceUri', 'documentId');
        this._documentServiceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this._documentServiceUrlKey));
    }
    DocumentOcrPreviewControlComponent.prototype.ngOnInit = function () {
        if (file_utils_1.isImage(this.format) && !file_utils_1.isTiff(this.format)) {
            this.getImage();
        }
        else {
            this.getDocumentPageData();
        }
        this.getDocumentContent();
    };
    DocumentOcrPreviewControlComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    DocumentOcrPreviewControlComponent.prototype.onPrev = function () {
        this.pageNumber--;
        this.getDocumentPageData();
    };
    DocumentOcrPreviewControlComponent.prototype.onNext = function () {
        this.pageNumber++;
        this.getDocumentPageData();
    };
    DocumentOcrPreviewControlComponent.prototype.zoomIn = function () {
        if (this.previewPinch.pinchZoom.scale < 6) {
            var newScale = (this.previewPinch.pinchZoom.scale + 0.20) > 6 ? 6 : (this.previewPinch.pinchZoom.scale + 0.20);
            this.previewPinch.pinchZoom.setZoom({ scale: newScale });
        }
    };
    DocumentOcrPreviewControlComponent.prototype.zoomOut = function () {
        if (this.previewPinch.pinchZoom.scale > 1) {
            var newScale = (this.previewPinch.pinchZoom.scale - 0.20) < 1 ? 1 : (this.previewPinch.pinchZoom.scale - 0.20);
            this.previewPinch.pinchZoom.setZoom({ scale: newScale });
        }
    };
    DocumentOcrPreviewControlComponent.prototype.getImage = function () {
        var _this = this;
        var entityId = this.entity ? this.entity.getInstanceId() : null;
        this.documentOperationsService.getDocument(this.attachmentId, this.category, entityId, this.documentRootField)
            .pipe(operators_1.switchMap(function (blob) { return from_1.from(static_method_1.blobToBase64(blob)); }), operators_1.takeUntil(this._destroy$))
            .subscribe(function (img) {
            _this._image = img;
            _this._isReady = true;
            _this.setMaxScale();
        }, function (err) {
            _this._isReady = true;
        });
    };
    DocumentOcrPreviewControlComponent.prototype.getDocumentPageData = function () {
        var _this = this;
        var entityId = this.entity ? this.entity.getInstanceId() : null;
        this.documentOperationsService.convertDocumentPage(this.attachmentId, this.pageNumber, this.category, entityId, this.documentRootField, 'png')
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.pagesCount = res.properties[converted_document_1.PAGES_COUNT];
            _this._documentPageImg = res.content;
            _this._prefix = "data:" + res.contentMimeType + ";base64,";
            _this._isReady = true;
            _this.setMaxScale();
        }, function (err) {
            _this._isReady = true;
        });
    };
    DocumentOcrPreviewControlComponent.prototype.getDocumentContent = function () {
        var _this = this;
        this._documentServiceUrl$.pipe(operators_1.switchMap(function (serviceUri) {
            var contentUrl = _this._documentContentPath.replaceTemplate({
                'serviceUri': serviceUri,
                'documentId': _this.attachmentId.toString()
            });
            var headers = new http_1.HttpHeaders().set('Content-Type', 'text/xml');
            var entityId = _this.entity ? _this.entity.getInstanceId() : null;
            return _this.deService.getDocumentToken(_this.category, entityId, _this.documentRootField).pipe(operators_1.switchMap(function (token) {
                var params = new http_1.HttpParams().set('authInfo', token);
                return _this.http.get(contentUrl, { headers: headers, params: params, responseType: 'text' });
            }));
        }), operators_1.catchError(function (err) { return Observable_1.Observable.throw(err); })).subscribe(function (res) {
            _this.textContent = res;
        });
    };
    DocumentOcrPreviewControlComponent.prototype.setMaxScale = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.previewPinch) {
                _this.previewPinch.pinchZoom.maxScale = 6;
            }
        }, 0);
    };
    Object.defineProperty(DocumentOcrPreviewControlComponent.prototype, "pageNumber", {
        get: function () {
            return this._pageNumber;
        },
        set: function (value) {
            this._pageNumber = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentOcrPreviewControlComponent.prototype, "pagesCount", {
        get: function () {
            return this._pagesCount;
        },
        set: function (value) {
            this._pagesCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentOcrPreviewControlComponent.prototype, "previewImg", {
        get: function () {
            if (this._image) {
                return this._image;
            }
            return this._prefix + this._documentPageImg;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentOcrPreviewControlComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentOcrPreviewControlComponent.prototype, "image", {
        get: function () {
            return this._image;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.ViewChild('previewPinch'),
        __metadata("design:type", Object)
    ], DocumentOcrPreviewControlComponent.prototype, "previewPinch", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], DocumentOcrPreviewControlComponent.prototype, "attachmentId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], DocumentOcrPreviewControlComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentOcrPreviewControlComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentOcrPreviewControlComponent.prototype, "documentRootField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], DocumentOcrPreviewControlComponent.prototype, "format", void 0);
    DocumentOcrPreviewControlComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-document-ocr-preview',
            styles: [require('./document-ocr-preview-control.component.css')],
            template: require('./document-ocr-preview-control.component.html')
        }),
        __metadata("design:paramtypes", [document_operations_service_1.DocumentOperationsService,
            idm_de_service_client_js_1.DeService,
            http_1.HttpClient,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], DocumentOcrPreviewControlComponent);
    return DocumentOcrPreviewControlComponent;
}());
exports.DocumentOcrPreviewControlComponent = DocumentOcrPreviewControlComponent;
var templateObject_1;
//# sourceMappingURL=document-ocr-preview-control.component.js.map